<template>
  <div class="">
    <div class="mainContent">
      <div class="bigTitleName">{{ title.bigName }}</div>
      <div class="checkNav">
        <div
          class="navItem"
          v-for="(v, i) in title.childName"
          :class="currentCount == i ? 'currentNav' : ''"
          @click="checkCurrent(v, i)"
        >
          {{ v.name }}
          <div class="shu" v-if="currentCount == i"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { onMounted, reactive, ref, defineProps, defineEmits, watch } from 'vue';
import { useRoute, useRouter, onBeforeRouteUpdate } from 'vue-router';
let currentCount = ref(0);
const router = useRouter();

const emit = defineEmits(['checkCurrent']);
function checkCurrent(v, i) {
  currentCount.value = i;
  emit('currentNav', { data: v.name });
  router.push(v.path);
}
const props = defineProps({
  title: {
    type: Object,
    default: () => {
      return {};
    },
  },
  checkCurrentName: {
    type: String,
    default: '',
  },
});
watch(
  () => router.currentRoute.value,
  (newValue) => {
    console.log('newValue', newValue);
    console.log(props.title);
    props.title.childName.forEach((v, i) => {
      if (newValue.name == v.name) {
        currentCount.value = i;
      }
    });
  },
  { immediate: true }
);
onMounted(() => {});
</script>
<style lang="less" scoped>
.mainContent {
  display: flex;
  flex-direction: column;
  .bigTitleName {
    width: 240px;
    height: 66px;
    background: #2270ac;
    border-radius: 0px 0px 0px 0px;
    opacity: 1;
    font-size: 22px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    text-indent: 24px;
    line-height: 66px;
  }
  .navItem {
    width: 240px;
    height: 60px;
    background: #eeeeee;
    border-radius: 0px 0px 0px 0px;
    opacity: 1;
    text-indent: 24px;
    font-size: 18px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    line-height: 60px;
    border-bottom: 1px solid #fff;
    cursor: pointer;
    position: relative;
  }
  .currentNav {
    background: #ffffff;
    color: #2270ac;
  }
  .shu {
    width: 4px;
    height: 20px;
    background: #2270ac;
    position: absolute;
    left: 0;
    top: 20px;
  }
}
</style>
